"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SuperDrawerContent = void 0;
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const framer_motion_1 = require("framer-motion");
const BeamContext_1 = require("../BeamContext");
const Button_1 = require("../Button");
const useSuperDrawer_1 = require("./useSuperDrawer");
const Css_1 = require("../../Css");
const utils_1 = require("./utils");
/**
 * Helper component to place the given children and actions into the appropriate
 * DOM format to render inside the SuperDrawer.
 *
 * NOTE: This does not include the header props since the caller will be the one
 * that knows how to handle the title, prev/next link and the onClose handler.
 */
const SuperDrawerContent = ({ children, actions }) => {
    var _a, _b;
    const { closeDrawerDetail } = (0, useSuperDrawer_1.useSuperDrawer)();
    const { drawerContentStack: contentStack } = (0, BeamContext_1.useBeamContext)();
    // Determine if the current element is a new content element or an detail element
    const { kind } = (_a = contentStack.current[contentStack.current.length - 1]) !== null && _a !== void 0 ? _a : {};
    const firstContent = (_b = contentStack.current[0]) === null || _b === void 0 ? void 0 : _b.opts;
    const { width = utils_1.SuperDrawerWidth.Normal } = firstContent !== null && firstContent !== void 0 ? firstContent : {};
    function wrapWithMotionAndMaybeBack(children) {
        if (kind === "open") {
            return ((0, jsx_runtime_1.jsx)(framer_motion_1.motion.div, { css: Css_1.Css.p3.fg1.oa.$, children: children }, "content"));
        }
        else if (kind === "detail") {
            return ((0, jsx_runtime_1.jsxs)(framer_motion_1.motion.div, { css: Css_1.Css.px3.pt2.pb3.fg1.$, animate: { overflow: "auto" }, transition: { overflow: { delay: 0.3 } }, children: [(0, jsx_runtime_1.jsx)(Button_1.Button, { label: "Back", icon: "chevronLeft", variant: "tertiary", onClick: closeDrawerDetail }), (0, jsx_runtime_1.jsx)(framer_motion_1.motion.div, { initial: { x: width, opacity: 0 }, animate: { x: 0, opacity: 1 }, transition: { ease: "linear", duration: 0.3, opacity: { delay: 0.15 } }, exit: { x: width, opacity: 0 }, css: Css_1.Css.pt2.$, children: children })] }, "content"));
        }
        else {
            // Hides content changes when closing the drawer
            // TODO: Potentially use a boolean to trigger close action so content does
            // not need to disappear during exit.
            return (0, jsx_runtime_1.jsx)(framer_motion_1.motion.div, { css: Css_1.Css.p3.fg1.$, style: { overflow: "auto" } }, "content");
        }
    }
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [wrapWithMotionAndMaybeBack(children), actions && ((0, jsx_runtime_1.jsx)("footer", { css: Css_1.Css.bt.bcGray200.p3.df.aic.jcfe.$, children: (0, jsx_runtime_1.jsx)("div", { css: Css_1.Css.df.gap1.$, children: actions.map((buttonProps, i) => ((0, jsx_runtime_1.jsx)(Button_1.Button, { ...buttonProps }, i))) }) }))] }));
};
exports.SuperDrawerContent = SuperDrawerContent;
